import React from 'react';
import { Modal, Grid, Card, CardContent, Typography, Button, Tooltip, Stack } from '@mui/material';
import styles from './ConfirmModal.module.scss';
import { useTranslation } from 'react-i18next';

interface ConfirmModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({ open, onClose, onConfirm }) => {
  const { t } = useTranslation();

  return (
    <Modal open={open} onClose={onClose}>
      <Grid component='div' container className={styles.modal_container}>
        <Grid component='div' size={{ xs: 12, sm: 8, md: 6, lg: 4 }}>
          <Card>
            <CardContent sx={{ paddingBottom: '16px !important' }}>
              <Typography variant='body1' className={styles.modal_text}>
                {t('confirmModal.textAlert')}
              </Typography>
              <Stack
                component='div'
                direction='row'
                className={styles.modal_actions}
                style={{ gap: '8px', flexWrap: 'wrap', justifyContent: 'flex-end' }}
              >
                <Tooltip title={t('confirmModal.tooltip')} placement='bottom'>
                  <Button
                    id='confirmModalDiscardBtn'
                    onClick={onConfirm}
                    variant='contained'
                    className='btn-default btn-action-basic btn-cancel'
                    sx={{ flexShrink: 0 }}
                  >
                    {t('confirmModal.discard')}
                  </Button>
                </Tooltip>
                <Button
                  id='confirmModalSaveBtn'
                  onClick={onClose}
                  variant='contained'
                  className='btn-default btn-action-basic'
                >
                  {t('confirmModal.save')}
                </Button>
              </Stack>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Modal>
  );
};

export default ConfirmModal;
